import React, { PureComponent } from "react";
import axios from "axios";

import { getLanguage } from "../../Translation/Translation";

import "./404.css";

export default class CustomPageContent extends PureComponent {
  state = { rawHtml: "", error: false };

  componentDidMount() {
    this._getRawHtml();
  }

  _getRawHtml = async () => {
    // NOTE: this url has to change with production build
    try {
      const { slug } = this.props.match.params;
      const { url } = this.props;
      const response = await axios.get(
        `${url}/api/pages/${slug}/html?lang=${getLanguage()}`
      );
      this.setState({
        rawHtml: response.data.translation.server_generated_html,
      });

      console.log(response.data.selected_template);
      switch (response.data.selected_template) {
        case "1":
          require("./template1.css");
          break;
        case "2":
          console.log("HERE");
          require("./template2.css");
          break;
        case "3":
          require("./template3.css");
          break;
        case "4":
          require("./template4.css");
          break;
        default:
          require("./template1.css");
          break;
      }
    } catch (e) {
      this.setState({ error: true });
    }
  };

  _createMarkup = () => {
    const { rawHtml } = this.state;
    return { __html: rawHtml.normalize() };
  };

  render() {
    const { error } = this.state;
    return (
      <div>
        {!error ? (
          <div dangerouslySetInnerHTML={this._createMarkup()} />
        ) : (
          <div className="FourOFourContainer">404 Page not found</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CustomPage/CustomPageContent.js